
                                                                                                                                                                                                                                                                                                    
<template>

    <div class="app-container" v-if="canList">
        <div class="filter-container">
                            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                          placeholder="编码"
                          v-model="listQuery.entity.secCode.code">
                </el-input>
                            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                          placeholder="名字"
                          v-model="listQuery.entity.secCode.name">
                </el-input>
                            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                          placeholder="用户编码"
                          v-model="listQuery.entity.secCode.userCode">
                </el-input>
                                                    <el-date-picker
                        @change='handleFilter'
                        value-format = "yyyy-MM-dd HH:mm:ss"
                        class="filter-item input"
                        v-model="listQuery.entity.secCode.times"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="绑定时间开始日期"
                        end-placeholder="绑定时间结束日期">
                </el-date-picker>
<!--                            <el-date-picker-->
<!--                        @change='handleFilter'-->
<!--                        value-format = "yyyy-MM-dd HH:mm:ss"-->
<!--                        class="filter-item input"-->
<!--                        v-model="listQuery.entity.secCode.lastTimes"-->
<!--                        type="datetimerange"-->
<!--                        range-separator="至"-->
<!--                        start-placeholder="上次时间开始日期"-->
<!--                        end-placeholder="上次时间结束日期">-->
<!--                </el-date-picker>-->
            
            <div style="display: inline-block">

            <el-button style="margin-left: 10px;" class="filter-item" type="primary" v-waves icon="el-icon-search" @click="handleFilter">查找
            </el-button>
            <el-button class="filter-item" style="margin-left: 10px;" @click="handleCreate" type="primary"
                  v-if="canSave"     icon="el-icon-edit">添加
            </el-button>
            <el-button class="filter-item" type="primary" :loading="downloadLoading" v-waves icon="el-icon-download"
                       @click="handleDownload">导出
            </el-button>
              <el-button class="filter-item" type="primary" :loading="downloadLoading" v-waves icon="el-icon-upload2"
                         @click="()=>$refs.file.click()">导入
              </el-button>

              <input style="display: none" ref="file"  @change="upload" type="file">
        </div>
        </div>

        <el-table :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;">
            <yf-table-column align="center" label="ID">
                <template slot-scope="scope">
                    <span>{{scope.row.secCode.id}}</span>
                </template>
            </yf-table-column>
                            <yf-table-column align="center" label="编码"  >
                    <template slot-scope="scope">
                        <span v-if="scope.row.secCode">{{scope.row.secCode.code}}</span>
                    </template>
                </yf-table-column>
                            <yf-table-column align="center" label="名字"  >
                    <template slot-scope="scope">
                        <span v-if="scope.row.secCode">{{scope.row.secCode.name}}</span>
                    </template>
                </yf-table-column>
                            <yf-table-column align="center" label="用户编码"  >
                    <template slot-scope="scope">
                        <span v-if="scope.row.secCode">{{scope.row.secCode.userCode}}</span>
                    </template>
                </yf-table-column>
                            <yf-table-column align="center" label="查询次数"  >
                    <template slot-scope="scope">
                        <span v-if="scope.row.secCode">{{scope.row.secCode.num}}</span>
                    </template>
                </yf-table-column>
                                                    <yf-table-column align="center" label="绑定时间" width="160" >
                    <template slot-scope="scope">
                        <span  v-if="scope.row.secCode">{{parseTime(scope.row.secCode.time)}}</span>
                    </template>
                </yf-table-column>
                            <yf-table-column align="center" label="上次时间" width="160" >
                    <template slot-scope="scope">
                        <span  v-if="scope.row.secCode">{{parseTime(scope.row.secCode.lastTime)}}</span>
                    </template>
                </yf-table-column>
            
            <yf-table-column align="center" label="操作" width="230" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button type="primary"  v-if="canUpdate"  size="mini" @click="handleUpdate(scope)">编辑</el-button>
                    <el-button  v-if="canSave"  size="mini" type="danger"
                               @click="handleDelete(scope)">删除
                    </el-button>
                </template>
            </yf-table-column>

        </el-table>

        <div class="pagination-container" style="margin-top: 20px">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                           layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

        <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
            <el-form :rules="rules" ref="dataForm" :model="temp" label-position="left" label-width="120px"
                     style='width: 450px; margin-left:50px;'>
                                    <el-form-item label="编码" prop="secCode.code">
                        <el-input v-model="temp.secCode.code"></el-input>
                    </el-form-item>
                                    <el-form-item label="名字" prop="secCode.name">
                        <el-input v-model="temp.secCode.name"></el-input>
                    </el-form-item>
                                    <el-form-item label="用户编码" prop="secCode.userCode">
                        <el-input v-model="temp.secCode.userCode"></el-input>
                    </el-form-item>
                                    <el-form-item label="查询次数" prop="secCode.num">
                        <el-input v-model="temp.secCode.num"></el-input>
                    </el-form-item>
                                                                    <el-form-item label="绑定时间" prop="secCode.time">
                        <el-date-picker v-model="temp.secCode.time" type="datetime"
                                        value-format="yyyy-MM-dd HH:mm:ss" placeholder="绑定时间">
                        </el-date-picker>
                    </el-form-item>
                                    <el-form-item label="上次时间" prop="secCode.lastTime">
                        <el-date-picker v-model="temp.secCode.lastTime" type="datetime"
                                        value-format="yyyy-MM-dd HH:mm:ss" placeholder="上次时间">
                        </el-date-picker>
                    </el-form-item>
                                
                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogForm">取消</el-button>
                <el-button v-if="dialogStatus=='create'" type="primary" @click="createData">确认</el-button>
                <el-button v-else type="primary" @click="updateData">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<style type="stylus">
    .filter-container {
        /*padding-bottom: 20px;*/
    }
    .filter-item{
        margin-bottom :10px;
    }
    .filter-item.input{
        /*line-height: 60px*/
        margin-right :10px;
    }
</style>

<script>
    import {list,options,down,upload,info, save, update, remove} from '@/api/sec_code'
    import waves from '@/directive/waves' // 水波纹指令
    import {downExcel} from '@/utils/down.js'
        import {parseTime} from '@/utils'
    
    
    import { mapGetters } from 'vuex'
    import { hasAuth } from '@/utils/auth'
    export default {
        name: 'test',
        directives: {
            waves
        },
      components:{
                },
        data() {
            return {
                tableKey: 0,
                list: null,
                total: null,
                listLoading: true,
                            time : null
                ,
                            lastTime : null
                ,
                            listQuery:{
                        page: 1,
                        limit:20,
                        order:'secCode.id desc',
                        entity:{
                                            secCode:
                        {
                                                            id :null  ,                                                            code :null  ,                                                            name :null  ,                                                            userCode :null  ,                                                            num :null  ,                                                            time :null  ,                                                            lastTime :null                                                      }
                                                            }},
                                        temp:{

                                    secCode:
                    {
                                                    id :null  ,                                                    code :null  ,                                                    name :null  ,                                                    userCode :null  ,                                                    num :null  ,                                                    time :null  ,                                                    lastTime :null                                              }
                                    

                }
        ,
            dialogFormVisible: false,
            dialogStatus:'',
            textMap:{
                update: '修改',
                create:'新增'
            },
                rules:
            {
                                                                                                                                                'secCode.code' : [
                                                    {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                                                ]
                                                ,
                                                                                                                                                        'secCode.name' : [
                                                    {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                                                ]
                                                ,
                                                                                                                                                        'secCode.userCode' : [
                                                    {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                                                ]
                                                ,
                                                                                                                                                        'secCode.num' : [
                                                    {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                                                ]
                                                ,
                                                                                                                                                        'secCode.time' : [
                                                    {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                                                ]
                                                ,
                                                                                                                                                        'secCode.lastTime' : [
                                                    {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                                                ]
                                                                        }
        ,
            downloadLoading: false,
            qData:
            {
                token: '',
                key: ''
            }
        }
        },
        activated() {
            this.getList()
            this.getOptions()
        },
        computed: {
                ...mapGetters([
                    'perms'
                ]),
        canSave() {
            return hasAuth(this.perms, 'sec:code:save')
        },
        canDelete() {
            return hasAuth(this.perms, 'sec:code:delete')
        },
        canUpdate() {
            return hasAuth(this.perms, 'sec:code:update')
        },
        canList() {
            return hasAuth(this.perms, 'sec:code:list')
        }
    },
        methods: {
                            parseTime(time){
                    if(!time)return ''
              return  parseTime(time,'{y}-{m}-{d} {h}:{i}:{s}')
            },
                        getList() {
                this.listLoading = true
                list(this.listQuery).then(response => {
                    this.list = response.data.list
                this.total = response.data.total
                this.listLoading = false
            })
            },
            getOptions(){
                options().then(res => {
                                    })
            },
            handleFilter() {
                this.listQuery.page = 1
                this.getList()
            },
            handleSizeChange(val) {
                this.listQuery.limit = val
                this.getList()
            },
            handleCurrentChange(val) {
                this.listQuery.page = val
                this.getList()
            },
            handleModifyStatus(row, status) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                })
                row.status = status
            },
            beforeFormShow(row){
                this.resetTemp(row) // 更新数据
            },
            afterFormShow(row){

            },
            beforeFormCommit(){

            },
            resetTemp(row) {
                    this.temp = {
                                                secCode:{}
                                                                    }
                    if (row) {
                        this.temp = Object.assign({}, row) // copy obj
                    }

            },
            handleCreate() {
                this.beforeFormShow()
                this.dialogStatus = 'create'
                this.dialogFormVisible = true
                this.$nextTick(() => {
                    this.afterFormShow()
                    this.$refs['dataForm'].clearValidate()
            })
            },
            handleDelete(scope) {
                this.index = scope.$index
                // this.beforeFormShow(scope.row)
                // this.temp = Object.assign({}, row) // copy obj
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // this.$message({
                    //   type: 'success',
                    //   message: '删除成功!'
                    // })
                    this.deleteData()
            }).
                catch(() => {
                    this.$message({
                    type: 'error',
                    message: '删除失败'
                })
            })
            },
            createData() {
                this.$refs['dataForm'].validate((valid) => {
                    if(valid) {
                        this.beforeFormCommit()
                        save(this.temp).then(res => {
                            this.temp = res.data
                        // this.list.unshift(this.temp)
                          this.getList()
                        this.closeDialogForm()
                        this.$notify({
                            title: '成功',
                            message: '创建成功',
                            type: 'success',
                            duration: 2000
                        })
                    })
                    }
                }
            )
            },
            deleteData() {
                // const ids = [this.temp.secCode.id]
                const ids = [this.list[this.index].secCode.id]
                remove({ids:ids}).then(res => {
                    // 从当前队列中移除
                    this.list.splice(this.index, 1)
                this.$notify({
                    title: '成功',
                    message: '删除成功',
                    type: 'success',
                    duration: 2000
                })
            })
            },
            handleUpdate(scope) {
                this.beforeFormShow(scope.row)
                info(scope.row.secCode.id).then(res => {
                            this.temp = res.data
                            this.dialogStatus = 'update'
                            this.dialogFormVisible = true
                            this.$nextTick(() => {
                                this.$refs['dataForm'].clearValidate()
                            })
                    })
            },
            updateData() {
                this.$refs['dataForm'].validate((valid) => {
                    if(valid) {
                        this.beforeFormCommit()
                        update(this.temp).then(() => {
                            // this.list.splice(this.index, 1, this.temp)
                            this.getList()
                        this.closeDialogForm()
                        this.$notify({
                            title: '成功',
                            message: '更新成功',
                            type: 'success',
                            duration: 2000
                        })
                    })
                    }
                }
            )
            },
            closeDialogForm() {
                this.dialogFormVisible = false
            },
            upload(e){
              upload(e.target.files[0]).then(res=>{
                this.$notify({
                  title: '成功',
                  message: '上传成功!',
                  type: 'success',
                  duration: 2000
                })
                this.getList()
              })
            },
            handleDownload() {
                this.downloadLoading = true
                down(this.listQuery).then(res=>{
                    downExcel(res)
                    this.downloadLoading = false
                    this.$notify({
                        title: '成功',
                        message: '下载成功',
                        type: 'success',
                        duration: 2000
                    })
                })
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            },
            // formatJson(filterVal, jsonData) {
            //     return jsonData.map(v => filterVal.map(j => {
            //         return v[j]
            //     }
            // ))
            // },
        }
    }
</script>
